module.exports = __webpack_public_path__ + "img/medal_svip5.c392ba7.png";